import Skeleton from "react-loading-skeleton";
import { DarkSkeletonTheme, TitleSkeleton } from "./shared";

const ContattiSkeleton = () => (
  <DarkSkeletonTheme>
    <div className="mt-24 lg:mt-40" aria-busy="true" aria-live="polite">
      <section className="bg-empty pt-16 lg:pt-32 px-10 lg:px-24">
        <div className="mb-8 lg:mb-0 flex justify-center lg:justify-start">
          <TitleSkeleton />
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 mt-8">
          <div className="flex flex-col gap-4">
            <div className="flex gap-2 items-center">
              <Skeleton circle width={24} height={24} />
              <Skeleton height={20} width={180} />
            </div>
            <div className="flex gap-2 items-center">
              <Skeleton circle width={24} height={24} />
              <Skeleton height={20} width={220} />
            </div>
          </div>
          <div className="flex flex-col gap-4">
            <div className="flex gap-2 items-center">
              <Skeleton circle width={24} height={24} />
              <Skeleton height={20} width={240} />
            </div>
            <div className="flex gap-2 items-center">
              <Skeleton circle width={24} height={24} />
              <Skeleton height={20} width={280} />
            </div>
          </div>
        </div>
      </section>

      <section className="my-10 px-10 lg:px-24">
        <div className="mb-16 flex justify-center lg:justify-start">
          <Skeleton className="max-w-xl w-full" height={36} />
        </div>
        <div className="flex justify-center">
          <Skeleton className="!max-w-md !w-full" height={480} borderRadius={4} />
        </div>
      </section>

      <section className="my-10 px-10 lg:px-24 pb-10">
        <div className="mb-8 flex justify-center lg:justify-start">
          <TitleSkeleton />
        </div>
        <div className="w-full max-w-[600px]">
          <Skeleton className="!w-full !max-w-full" height={450} borderRadius={4} />
        </div>
      </section>
    </div>
  </DarkSkeletonTheme>
);

export default ContattiSkeleton;
